<template lang="pug">
  .related(v-if="data")
    .related-title(v-if="data.HeaderText") {{data.HeaderText}}
    .related-properties
      .property(v-for="(property, i) in data.Properties", :key="i")
        figure.property-graphic
          img(:src="property.Image", :alt="property.Name")
        .property-content
          .property-title(v-html="property.Name", :style="styles.primary.color")
          router-link.property-detail(to="/", :style="styles.primary.color")
            span More Details
</template>

<script>
export default {
  props: ['data', 'theme'],
  computed: {
    styles () {
			return {
				primary: {
					background: `background:${this.theme.primary};`,
					color: `color:${this.theme.primary}`
				},
				secondary: {
					background: `background:${this.theme.secondary};`,
					color: `color:${this.theme.secondary}`
				}
			}
		}
  }
}
</script>

<style lang="scss">
  // @import "../../assets/styles/abstracts";

  .related {
    border-top: 1px solid $gray;
    padding: 40px 20px 0;
    margin: 40px -20px 0;
    .related-title {
      font-family: "Din Pro";
      font-size: 20px;
      color: $red;
      line-height: 1;
      padding: 10px 0;
      margin-bottom: 20px;
    }
  }

  .related-properties {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    @media (min-width: 768px) {
      margin: 0 -20px;
    }
    .property {
      box-shadow: 0 0 5px $gray;
      display: flex;
      flex: 1 1 100%;
      flex-direction: column;
      justify-content: stretch;
      margin-bottom: 40px;
      @media (min-width: 768px) {
        flex: 1 1 calc(50% - 40px);
        margin-left: 20px;
        margin-right: 20px;
      }
      @media (min-width: 992px) {
        flex: 1 1 calc(33.333% - 40px);
      }
      @media (min-width: 1170px) {
        flex: 0 1 calc(25% - 40px);
      }
      .property-graphic {
        display: block;
        margin: 0;
        padding: 15px;
        width: 100%;
        img {
          display: block;
          max-width: 100%;
          width: 100%;
        }
      }
      .property-content {
        background: $offWhite;
        display: flex;
        flex: 1 1 auto;
        flex-direction: column;
        padding: 15px;
      }
      .property-title {
        color: $red;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 15px;
      }
      .property-detail {
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
        font-family: "Din Pro";
        font-size: 14px;
        padding: 10px;
        border: 1px solid currentColor;
        line-height: 1;
        margin-top: auto;
        transition: 0.25s ease-out;
        text-align: center;
        &:hover {
          color: $white !important;
          background: var(--color_primary);
          text-decoration: none;
        }
      }
    }
  }

</style>
